$(document).ready(function(){

	var $sliderProject = $('.slider--project');
	var sliderProjectSettings = {
		arrows: true,
		dots: false,
		infinite: false,
	};
  $sliderProject.slick(sliderProjectSettings);

});